module.exports = __webpack_public_path__ + "static/img/10.daebefd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/5/eng/10.png
// module id = TWj4
// module chunks = 0